import { useSelector } from 'react-redux';
import AudioPlayer from '@/components/app/AudioPlayer';
import AudioPlayerStreamEvents from '@/components/app/AudioPlayerStreamEvents';
import MusicPlayerBar from '@/components/app/MusicPlayerBar';
import useAppFilter from '@/hooks/layout/useAppFilter';
import { selectKeakiePlaybackMode } from '@/state/selectors/audio';
import { AudioProvider } from '@/contexts/audio-playback/audio';
import { AudioSeekProvider } from '@/contexts/audio-playback/audio-seek';
import { AudioVolumeProvider } from '@/contexts/audio-playback/audio-volume';
import { AudioTrackSkipsProvider } from '@/contexts/audio-playback/audio-track-skips';
import { AudioTracklistProvider } from '@/contexts/audio-playback/audio-tracklist';

const BottomNavigationBar = () => {
  const { appIsFiltered } = useAppFilter();
  const keakiePlaybackMode = useSelector(selectKeakiePlaybackMode);

  return (
    <AudioProvider>
      <AudioVolumeProvider>
        <AudioSeekProvider>
          <AudioTracklistProvider>
            <AudioTrackSkipsProvider>
              <MusicPlayerBar isFiltered={ appIsFiltered } />
              <AudioPlayer readyToPlay={ !!keakiePlaybackMode } />
              <AudioPlayerStreamEvents />
            </AudioTrackSkipsProvider>
          </AudioTracklistProvider>
        </AudioSeekProvider>
      </AudioVolumeProvider>
    </AudioProvider>
  );
};

export default BottomNavigationBar;